import $ from 'jquery';

$(document).on('change', 'input[type=file]', function(event) {
    let $fileInput = $(event.currentTarget);
    let $fileCaption = $fileInput.parent('.file').find('.file-caption');
    if (!$fileCaption.length) {
        return;
    }
    let fileNames = [];

    for (let i = 0; i < $fileInput[0].files.length; i++) {
        fileNames.push($fileInput[0].files[i].name);
    }
    if (fileNames.length) {
        $fileCaption.text(fileNames.join(', '));
    } else {
        $fileCaption.data('defaultCaption');
    }
});